import Vue from "vue";

// States
const state = {
    loadingScreen: false,
};

// Getters
const getters = {
    loadingScreen: state => {
        return state.loadingScreen
    },

};

// Actions
const actions = {
    setLoading(context, payload) {
            context.commit('setLoadingHandler', { loading: payload.loading });
        },
};

// Mutations
const mutations = {
    setLoadingHandler(state, { loading }) {
        // Update loading state
        state.loadingScreen = loading;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}